import { render, staticRenderFns } from "./addLogisticsModal.vue?vue&type=template&id=1520d92a&scoped=true"
import script from "./addLogisticsModal.vue?vue&type=script&lang=js"
export * from "./addLogisticsModal.vue?vue&type=script&lang=js"
import style0 from "./addLogisticsModal.vue?vue&type=style&index=0&id=1520d92a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520d92a",
  null
  
)

export default component.exports